export default [

  {
    'artist': 'Welcome',
    'location': '',
    'length': '0:31',
    'length_seconds': '600',
    'tour_index': 1,
    'soundcloud_id': 342535190,
    'track_number': 0,
    'paragraph': '<p>The Ready Made Go project consists of a collection of new products that have been designed, developed and made (or found) especially for Ace Hotel London Shoreditch.</p><p><em>Modern Design Review</em> magazine curates the project. We intervene in the hotel’s usual procurement process and commission local designers and design groups to make objects that are then installed as part of the permanent interior of Ace Hotel London.</p><p>This is the third Ready Made Go collection and consists of five new objects; stools for Bulldog Café, salt &amp; pepper grinders for Hoi Polloi restaurant, café displays, mugs and coffee pots and tables for the lobby.</p><p>We seek to demonstrate the quality and diversity of design talent in London and take great pleasure in giving real commissions to independent designers and design studios, and in sharing the resulting solution-driven and exciting objects with the general public.</p>',
    'images':
    [
        {'src': '', 'caption': ''},
        {'src': '', 'caption': ''},
        {'src': '', 'caption': ''},
        {'src': '', 'caption': ''},
        {'src': '', 'caption': ''},
        {'src': '', 'caption': ''},
        {'src': '', 'caption': ''},
        {'src': '', 'caption': ''},
        {'src': '', 'caption': ''}
    ]
  },

  {
    'artist': 'Soft Baroque',
    'title': 'Finger Tables',
    'location': 'Lobby',
    'tour_index': 2,
    'length': '4:42',
    'length_seconds': '600',
    'soundcloud_id': 342535189,
    // 340510726
    'track_number': 1,
    'paragraph': '<p>The Rhombus and Arc Finger Tables feature a distinctive finger joint more commonly found in carpentry. Transposing elements across mediums and questioning the familiar is typical of Soft Baroque’s (Nicholas Gardner and Saša Štucin’s) approach. Here they have worked with Alusid; an exciting new material made from 100% recycled ceramic and glass that is as strong as stone and as malleable as ceramic.</p>',
    'images':
    [
        {'src': 'SB_product_sq.jpg', 'caption': null},
        {'src': 'SB1_making.jpg', 'caption': null},
        {'src': 'SB2_making.jpg', 'caption': null},
        {'src': 'SB3_making.jpg', 'caption': null},
        {'src': 'SB4_making.jpg', 'caption': null},
        {'src': 'SB5_making.jpg', 'caption': null},
        {'src': 'SB6_making.jpg', 'caption': null},
        {'src': 'SB7_making.jpg', 'caption': null},
        {'src': 'SB8_making.jpg', 'caption': null}
    ]
  },

  {
    'artist': 'Michael Marriott',
    'title': 'Totem Stool',
    'location': 'Bulldog Edition',
    'tour_index': 3,
    'length': '6:59',
    'length_seconds': '600',
    'soundcloud_id': 342535187,
    // 340510708
    'track_number': 2,
    'paragraph': '<p>The Totem stools are an exercise in economy and utility. Michael Marriott has made a stable and comfortable seat that maximises material and uses simple construction methods. These are clearly on display. The material used is Smile Plastics; an innovative sheet material made from 100% recycled waste plastic such as food containers, yoghurt pots and plastic bottles.</p>',
    'images':
    [
        {'src': 'MM_product_sq.jpg', 'caption': null},
        {'src': 'MM1_making.jpg', 'caption': null},
        {'src': 'MM2_making.jpg', 'caption': null},
        {'src': 'MM3_making.jpg', 'caption': null},
        {'src': 'MM4_making.jpg', 'caption': null},
        {'src': 'MM5_making.jpg', 'caption': null},
        {'src': 'MM6_making.jpg', 'caption': null},
        {'src': 'MM7_making.jpg', 'caption': null},
        {'src': 'MM8_making.jpg', 'caption': null}
    ]
  },

  {
    'artist': 'Ian Mcintyre',
    'title': 'A1 Mug and Coffee Pot',
    'location': 'Bulldog Edition',
    'tour_index': 4,
    'length': '4:31',
    'soundcloud_id': 342535185,
    'track_number': 3,
    'paragraph': '<p>The A1 mug is intended as a do-all item for Ace, to be used throughout the hotel. Ian McIntyre has created an archetypal vessel that is tough, hardy and without pretension. The A1 Coffee Pot is similarly functional. Ease and efficiency of making has dictated the defining characteristics of the items; a moulded cylindrical body that is consistent and regular and a hand-shaped handle that is roughly finished and characterful.</p>',
    'images':
    [
        {'src': 'IM_product_sq.jpg', 'caption': null},
        {'src': 'IM1_making.jpg', 'caption': null},
        {'src': 'IM2_making.jpg', 'caption': null},
        {'src': 'IM3_making.jpg', 'caption': null},
        {'src': 'IM4_making.jpg', 'caption': null},
        {'src': 'IM5_making.jpg', 'caption': null},
        {'src': 'IM6_making.jpg', 'caption': null},
        {'src': 'IM7_making.jpg', 'caption': null},
        {'src': 'IM8_making.jpg', 'caption': null}
    ]
  },

  {
    'artist': 'James Shaw',
    'title': 'Plastic Baroque Counter Displays',
    'location': 'Bulldog Edition',
    'tour_index': 5,
    'length': '3:55',
    'length_seconds': '600',
    'soundcloud_id': 342535181,
    'track_number': 4,
    'paragraph': '<p>Plastic Baroque is a method of making that James Shaw invented during his graduate year at the Royal College of Art. It involves a home-made, hand-held gun that melts and extrudes recycled plastic. The resulting material is expressive, structural and elaborate. James has applied the process to building counter display stands and tidies for Bulldog Café.</p>',
    'images':
    [
        {'src': 'JS_product_sq.jpg', 'caption': null},
        {'src': 'JS1_making.jpg', 'caption': null},
        {'src': 'JS2_making.jpg', 'caption': null},
        {'src': 'JS3_making.jpg', 'caption': null},
        {'src': 'JS4_making.jpg', 'caption': null},
        {'src': 'JS5_making.jpg', 'caption': null},
        {'src': 'JS6_making.jpg', 'caption': null},
        {'src': 'JS7_making.jpg', 'caption': null},
        {'src': 'JS8_making.jpg', 'caption': null}
    ]
  },

  {
    'artist': 'Oscar Diaz',
    'title': 'Box Salt & Pepper Grinders',
    'location': 'Hoi Polloi',
    'tour_index': 6,
    'length': '2:16',
    'length_seconds': '600',
    'soundcloud_id': 342535143,
    'track_number': 5,
    'paragraph': '<p>Oscar Diaz has recycled a gesture in his Box salt and pepper grinders. The turning motion of the brass key is familiar and nostalgic, having been reappropriated from a childhood music box. Here the same motion is used to grind condiment. Oscar is concerned with elevating everyday objects and using industrial design to do so.</p>',
    'images':
    [
        {'src': 'OD_product_sq.jpg', 'caption': null},
        {'src': 'OD1_making.jpg', 'caption': null},
        {'src': 'OD2_making.jpg', 'caption': null},
        {'src': 'OD3_making.jpg', 'caption': null},
        {'src': 'OD4_making.jpg', 'caption': null},
        {'src': 'OD5_making.jpg', 'caption': null},
        {'src': 'OD6_making.jpg', 'caption': null},
        {'src': 'OD7_making.jpg', 'caption': null},
        {'src': 'OD8_making.jpg', 'caption': null}
    ]
  }

]



// WEBPACK FOOTER //
// ./src/Tracklist.js